// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"653":"e4137aef","707":"778e547c","960":"0d3627b8"}[chunkId] + ".chunk.js";
};